export default {
  shareMeta: {
    title: "Photo de <xx1> sur PixelHaha",
    description:
      "Téléchargez cette photo gratuite créée par <xx1> à l'aide du générateur d'images AI sur PixelHaha.",
  },
  home: {
    picTitle: "Images libres de droits",
    recentSearch: "Recherches récentes",
    clear: "clair",
    trendsSearch: "Recherches en vogue",
    details: "Détails",
    enhance: "Améliorer",
    reimagine: "Réimaginer",
  },
  search: {
    guess: "Vous pourriez aussi aimer",
    trending: "Tendance",
    newest: "Le plus récent",
    empty: "Il n'y a pas encore de résultats de recherche.",
    goCreate: "Va créer l'image",
    searchPlaceholder: "L'inspiration commence ici...",
  },
  detail: {
    report: "Rapport",
    downloadFree: "Télécharger gratuitement",
    prompt: "Rapide",
    more: "Vous pourriez aussi aimer",
    toCreate: "Créer",
    enhance: "Amélioration de la photo",
    invalid:
      "Lien indisponible. Le créateur a annulé la publication ou l'image n'est pas conforme.",
    generation:
      "PixelHaha vous propose une génération d'images de haute qualité.",
    exploreMore: "En savoir plus",
    jpg: "JPG",
    png: "PNG",
    download : "Le téléchargement a échoué. Veuillez vérifier votre connexion réseau et réessayer.",
  },
  trends: {
    bgTip: "Recherches en vogue",
    wrong: "Quelque chose s'est mal passé",
    retry: "Réessayer",
    top: "Haut",
    a: "A",
    b: "B",
    c: "C",
    d: "D",
    e: "E",
    f: "F",
    g: "G",
    h: "H",
    i: "I",
    j: "J",
    k: "K",
    l: "L",
    m: "M",
    n: "N",
    o: "O",
    p: "P",
    q: "Q",
    r: "R",
    s: "S",
    t: "T",
    u: "U",
    v: "V",
    w: "W",
    x: "X",
    y: "Y",
    z: "Z",
  },
  img: {
    notReviewed: "Cette image n'a pas été examinée",
    posting: "Affectation...",
    deleteQ: "confirmer la suppression ?",
    cancel: "Annuler",
    delete: "Supprimer",
  },
  ugcPage: {
    editName: "Modifier le nom",
    finish: "Finition",
    goHistory: "Accéder à l'historique de publication",
    tabWork: "Travail",
    tabFavorites: "Favoris",
    empty: "Aucune donnée",
    avatarTypeError: "Seuls les formats .png, .jpg, .webp sont pris en charge",
  },
  siteMap: {
    page: "Page",
    sort: "Trier",
    keywords: "Mots clés",
  },
  report: {
    title: "Contenu du rapport",
    text: "Pourquoi signalez-vous cela ?",
    reason1: "Violation des conditions d'utilisation",
    reason2: "Faible qualité",
    reason3: "Courrier indésirable",
    reason4: "Contenu sensible",
    reason5: "Autre",
    textplaceholder:
      "Veuillez décrire les problèmes que vous avez rencontrés, en étant aussi précis que possible.",
    submit: "Confirmer le rapport",
    toastSuccess: "Rapport envoyé avec succès. Nous l'examinerons bientôt.",
    toastFailed: "Échec de l'envoi du rapport, veuillez réessayer.",
  },
};
